import { Trial } from '../types'

export const trialCacheKey = {
  getTrialHospitals: (trialUid: Trial['uid']) =>
    [trialUid, 'trialHospitals'].join(),
  getRelatedTrialHospitals: () => 'relatedTrialHospital',
  getTrial: (trialUid: string) => [trialUid, 'trial'].join(),
  getFeatureFlags: (trialUid: string) => [trialUid, 'featureFlags'].join(),
}
